import { memo, ReactNode } from 'react';
import { Modal } from 'react-native';

export const Portal = memo(
  ({
    enabled,
    open,
    children,
    onRequestClose,
  }: {
    enabled?: boolean;
    open?: boolean;
    onRequestClose?: () => void;
    children?: ReactNode;
  }) => {
    if (!enabled) {
      return <>{children}</>;
    }
    return (
      <Modal
        visible={open}
        transparent={true}
        animationType="none"
        onRequestClose={onRequestClose}
      >
        {children}
      </Modal>
    );
  },
);
